import { API, graphqlOperation } from 'aws-amplify';
import gql from 'graphql-tag';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Observable from 'zen-observable-ts';

import {
  setGiideTabState,
  setProcessingRecording,
  setRecordingProcessingModalVisible,
  updateSubscription,
} from '../../actions';
import { OnTranscriptionFinishedSubscription } from '../../graphql/api';
import {
  IRecordingProcessingState,
  IState,
  Subscription,
} from '../../graphql/types';
import useRecording from '../useQuery/useRecording';
import useUser from '../useUser';

const onTranscriptionFinished = gql`
  subscription OnTranscriptionFinished($tenantID: String) {
    onTranscriptionFinished(tenantID: $tenantID) {
      id
      tenantID
    }
  }
`;

const useTranscribeSubscription = (stepIndex?: number) => {
  const dispatch = useDispatch();
  const sub = useSelector<IState, Subscription | undefined>(
    state => state.subscriptions.transcriptionFinished
  );

  const recordingProcessingState = useSelector<
    IState,
    IRecordingProcessingState | undefined
  >(state => state.recordingProcessingState);

  const { user } = useUser();
  const { fetchRecording } = useRecording();

  const subscribe = React.useCallback(() => {
    if (user?.tenantID) {
      const newObs = API.graphql(
        graphqlOperation(onTranscriptionFinished, { tenantID: user?.tenantID })
      );

      if (newObs instanceof Observable) {
        if (sub) {
          sub.unsubscribe();
        }

        const newSub = newObs.subscribe({
          next: (result: {
            value: { data: OnTranscriptionFinishedSubscription };
          }) => {
            if (recordingProcessingState?.state !== 'finished') {
              const recordingId = result.value.data.onTranscriptionFinished?.id;
              if (recordingId) {
                fetchRecording(recordingId, true, true);
                dispatch(setRecordingProcessingModalVisible(false));
                dispatch(setGiideTabState('transcript', stepIndex));
                dispatch(
                  setProcessingRecording({
                    state: 'finished',
                  })
                );
              }
            }
          },
          complete: () => console.log('completed transcribe subscription'),
          error: e => console.log(e),
        });
        dispatch(updateSubscription('transcriptionFinished', newSub));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, fetchRecording, dispatch, stepIndex, recordingProcessingState]);

  React.useEffect(() => {
    subscribe();
  }, [recordingProcessingState, subscribe]);

  return { subscribe, sub };
};

export default useTranscribeSubscription;
